// src/hooks/useRecipientPayoutEligibility.ts
//
// Mirrors useWithdrawalEligibility — same staleTime/gcTime so sidebar
// flag refresh is coherent across products.
import { useQuery } from "@tanstack/react-query";
import { recipientPayoutService } from "../services/recipientPayoutService";

export const useRecipientPayoutEligibility = () => {
  return useQuery({
    queryKey: ["recipient-payout-eligibility"],
    queryFn: () => recipientPayoutService.checkEligibility(),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 1,
    retryDelay: 1000,
    enabled: true,
  });
};
